<div class="message chat-msg" data-isodate="{{{o.time}}}" data-msgid="{{{o.msgid}}}">
    <canvas class="avatar chat-msg__avatar" height="36" width="36"></canvas>
    <div class="chat-msg__content">
        <span class="chat-msg__text">{{{o.__('Uploading file:')}}} <strong>{{{o.filename}}}</strong>, {{{o.filesize}}}</span>
        <progress value="{{{o.progress}}}"/>
    </div>
</div>
